export default __webpack_public_path__ + "static/media/property_236.15b08bc6.png";